import { render, staticRenderFns } from "./ExpressFastOrdersCreateAdmin.vue?vue&type=template&id=70068453&scoped=true"
import script from "./ExpressFastOrdersCreateAdmin.vue?vue&type=script&lang=js"
export * from "./ExpressFastOrdersCreateAdmin.vue?vue&type=script&lang=js"
import style0 from "./ExpressFastOrdersCreateAdmin.vue?vue&type=style&index=0&id=70068453&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70068453",
  null
  
)

export default component.exports